(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemist-designer"] && !Shopify.designMode) return;
  try {
    
  const baseURL = "https://daysjewelers.gemist.co/";
  
  window.onload = function() {

// Get the current URL of the parent page
    var url = window.location.href;

// Get the query string from the URL
    var queryString = url.split('?')[1];

// Create the iframe URL with the query string
    var iframeUrl = baseURL + "designer/engagement?" + queryString;

// Set the iframe's source URL
    var iframe = document.getElementById("designer-iframe");

    iframe.src = iframeUrl;
  };

  function removeItemsFromCart(items) {
    if (items.length<= 0) return;

  items.forEach(item => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(item)
      }).then(response => response.json()).then(data => {
        var event = new Event('cart:refresh');
        document.dispatchEvent(event);
      }).catch(error => console.error("Error removing item from cart:", error));
    }) 
    
  }

  window.addEventListener("cart:change", function(event) {
    let variant_id;
    event
      .detail
      .cart
      .items_removed
      .forEach(item => {
        variant_id = item.variant_id;
      });

    if (variant_id === undefined) {
      return;
    }

    fetch('/cart.js').then(response => response.json()).then(data => {
      let relatedItems = data.items.filter(item => item.properties._variant_id == variant_id);
      let removeItems = []
      relatedItems.forEach(item => {
        removeItems.push({
          id: item.key,
          quantity: item.quantity - 1
        });
      });

      removeItemsFromCart(removeItems);
    }).catch(error => {
      console.error('Error fetching cart items:', error);
    });
  });

  window.addEventListener("message", function(event) {
    const designerIframe = document.getElementById("designer-iframe");

    if (event.data) {
      try {
        const message = JSON.parse(event.data);
        switch (message.type) {
          case "buy":
            {
              function normalizeVariantId(rawVariantId) {
                if (rawVariantId === undefined || rawVariantId === null) {
                  return undefined;
                } else if (typeof rawVariantId === "number") {
                  return String(rawVariantId);
                } else if (typeof rawVariantId === "string" && rawVariantId.indexOf("/") !== -1) {
                  return rawVariantId.split("/").slice(-1)[0];
                } else {
                  return String(rawVariantId);
                }
              }

              var rawRingId = message.ring && message.ring.variantId !== undefined
                ? message.ring.variantId
                : message.product && message.product.Shopify && message.product.Shopify.productVariant;
              var rawDiamondId = message.diamond && message.diamond.variantId;
              
              var id = normalizeVariantId(rawRingId);
              var diamondId = normalizeVariantId(rawDiamondId);

              var size = message.size;
              var image = message.image;
              var ringItems = [];

              var product = {
                id: id,
                quantity: 1,
                properties: {
                  Size: size,
                  _gemist__ring: true,
                  _gemist__image: message.image
                }
              };

              var ring = message.ring || {};
              if (ring.band !== undefined) 
                product.properties.Band = ring.band;
              


              if (ring.carat !== undefined) 
                product.properties.Carat = ring.carat;
              


              if (ring.metal !== undefined) 
                product.properties.Metal = ring.metal;
              


              if (ring.shape !== undefined) 
                product.properties.Shape = ring.shape;
              


              if (ring.stone !== undefined) 
                product.properties.Stone = ring.stone;
              


              if (ring.style !== undefined) 
                product.properties.Style = ring.style;
              


              if (id && message.engravingText != "") {
                var engraving = {
                  id: "52264951415066",
                  quantity: 1,
                  properties: {
                    Text: message.engravingText.toUpperCase(),
                    Font: message.engravingFont.toUpperCase(),
                    _gemist__ring: true,
                    _gemist__image: image,
                    associatedMount: rawRingId
                  }
                };

                ringItems.push(engraving);
              }

              if (id) {
                ringItems.push(product);
              }

              if (diamondId) {
                ringItems.push({
                  id: diamondId,
                  quantity: 1,
                  properties: {
                    _gemist__diamond: true,
                    associatedMount: rawRingId
                  }
                });
              }

              if (! id && ! diamondId) {
                designerIframe.contentWindow.postMessage({type: "cart", status: "error", message: "No variant id"}, "*");
                break;
              }

              function isSoldOutError(data) {
                if (! data) 
                  return false;
                


                var text = [data.message, data.description].filter(Boolean).join(" ").toLowerCase();

                return data.status === 422 && text.indexOf("already sold out") !== -1;
              }

              function wait(ms) {
                return new Promise(function(resolve) {
                  setTimeout(resolve, ms);
                });
              }

              function addRingToCart(attempt) {
                var MAX_ATTEMPTS = 3;

                return fetch(window.Shopify.routes.root + "cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    "Accept": "application/json"
                  },
                  body: JSON.stringify(
                    {items: ringItems}
                  )
                }).then(function(response) {
                  return response.json().then(function(data) {
                    return {ok: response.ok, data: data};
                  });
                }).then(function(result) {
                  console.log("cart/add result", result, "attempt", attempt);

                  if (! result.ok) {
                    if (isSoldOutError(result.data) && attempt < MAX_ATTEMPTS) {
                      console.warn("Sold out error detected. Retrying in 3 seconds...", "attempt", attempt);

                      return wait(3000).then(function() {
                        return addRingToCart(attempt + 1);
                      });
                    }

                    throw new Error(result.data.description || result.data.message || "Add to cart failed");
                  }

                  return result;
                });
              }

              addRingToCart(1).then(function(result) {
                var GEMIST_CART_LOG = "[GemistDesigner/cart]";

                console.log(GEMIST_CART_LOG, "cart/add.js succeeded", {
                  attemptPayloadItems: ringItems.length,
                  responseItemCount: result.data && result.data.items
                    ? result.data.items.length
                    : null
                });

                designerIframe.contentWindow.postMessage({type: "cart", status: "added"}, "*");

                document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
                  detail: {
                    product: result.data,
                    addToCartBtn: null
                  },
                  bubbles: true
                }));

                console.log(GEMIST_CART_LOG, "dispatched ajaxProduct:added");

                var drawerHost = document.querySelector("[data-cart-drawer]");
                var cartDrawerInstance = window.cart;
                var cartType = window.theme && window.theme.settings
                  ? window.theme.settings.cartType
                  : undefined;

                console.log(GEMIST_CART_LOG, "drawer bridge preflight", {
                  cartType: cartType,
                  hasDataCartDrawer: Boolean(drawerHost),
                  hasIdCartDrawer: Boolean(document.getElementById("cart-drawer")),
                  hasWindowCart: Boolean(cartDrawerInstance),
                  getCartType: cartDrawerInstance
                    ? typeof cartDrawerInstance.getCart
                    : "n/a"
                });

                document.addEventListener(
                  "theme:cart:added",
                  function gemistLogCartAdded() {
                    console.log(GEMIST_CART_LOG, "theme:cart:added (drawer contents should be updated)");
                  },
                  { once: true }
                );

                document.addEventListener(
                  "theme:cart:open",
                  function gemistLogCartOpen() {
                    console.log(GEMIST_CART_LOG, "theme:cart:open (drawer opening)");
                  },
                  { once: true }
                );

                if (cartDrawerInstance && typeof cartDrawerInstance.getCart === "function") {
                  try {
                    cartDrawerInstance.getCart();
                    console.log(GEMIST_CART_LOG, "called window.cart.getCart()");
                  } catch (errGetCart) {
                    console.error(GEMIST_CART_LOG, "window.cart.getCart() threw", errGetCart);
                  }
                } else {
                  console.warn(
                    GEMIST_CART_LOG,
                    "skipped window.cart.getCart — not available (drawer will not refresh via theme CartDrawer)"
                  );
                }
              }).catch(function(error) {
                console.error("Error al agregar el anillo:", error);
                designerIframe.contentWindow.postMessage({
                  type: "cart",
                  status: "error",
                  message: String(
                    error && error.message
                      ? error.message
                      : error
                  )
                }, "*");
              });

              break;
            }
          case 'favorite':
            var {
              id
            } = message.product;

            fetch(baseURL + 'api/products/' + id + '/shmetadata').then(response => response.json()).then(data => {
              var {
                productId,
                handle
              } = data;

// create element to save
              var elementToSave = document.createElement('div');
              elementToSave.dataset.id = productId.split('/').slice(-1)[0];
              elementToSave.dataset.handle = handle;

// use the saveWishlist function that we made available from theme.js
              saveWishlist($(elementToSave));
            }).catch((error) => {
              console.error('Error:', error);
            });
            break;
          case 'updateParams':

// Get the parameter names from the message
            var paramNames = message.paramNames;
            var currentURL = new URL(window.location.href);

// Loop through the parameter names
            paramNames.forEach(function(paramName) {

// Retrieve the corresponding value from the message
              var paramValue = message[paramName];

// Modify the query parameter of the parent URL with the value
              if (paramValue !== undefined) {
                currentURL.searchParams.set(paramName, paramValue);
              }
            });

// Replace the parent URL with the modified URL
            window.history.replaceState({}, "", currentURL.toString());
            break;
          case 'download':
            const downloadHref = message.downloadHref;
            if (downloadHref) {
              window.open(downloadHref, "_blank");
            }
            break;
          case 'copywindowlocation':

// Get the current window location
            var windowLocation = window.location.href;

// Use the Clipboard API to copy the window location to the clipboard
            navigator
              .clipboard
              .writeText(windowLocation)
              .then(function() {
                console.log("Window location copied to clipboard successfully");
              })
              .catch(function(error) {
                console.error("Failed to copy window location to clipboard:", error);
              });
            break;
          case 'sendemail':
            let {emailContent, subject, recipient} = message;
            const currentPageLink = window.location.href;
            emailContent = emailContent.replace("{{currentPageLink}}", currentPageLink);

            const mailtoLink = `mailto:${recipient}?subject=${
              encodeURIComponent(subject)
            }&body=${
              encodeURIComponent(emailContent)
            }`;

            if (mailtoLink) {
              window.open(mailtoLink, "_blank");
            }
            break;
          case "requestfullscreen":
            // Reuse `designerIframe` from the listener scope above — a second `const` here
            // hoists across the whole `switch` and breaks other cases (TDZ / "before initialization").
            if (designerIframe) {
              void designerIframe.requestFullscreen();
            }
            break;
          case "openform":
            document.querySelector('.hidden-hulk-trigger').click();
            const iframe = document.querySelector('.pxFormGenerator iframe');

            if (iframe) {
              const base = iframe.src.split('?')[0];
              const params =  new URLSearchParams(iframe.src.split('?')[1]);

              params.set('DesignURL', window.location.href);
              iframe.src = `${base}?${params.toString()}`;
            }

            const interval = setInterval(() => {
                const form = document.querySelector('#cm9LTDvhhr7jMuf7Gc36pA');

                if (form) {
                    form.style.setProperty('display', 'block', 'important');
                    clearInterval(interval);
                }
            }, 5);
            
            break;
          case "requestParentWindowHref":
            if (designerIframe && designerIframe.contentWindow) {
              designerIframe.contentWindow.postMessage(window.location.href, "*");
            }
            break;
          default:
            break;
        }
      } catch (e) {
        // console.log("Designer error", e);
      }
    }
  }, false);

// This function sets the Designer's iframe's height by calculating the imperative elements (navbar, announcement bar) height,
// then subtracting their pixel values from the viewport's fullscreen space.
  document.addEventListener("DOMContentLoaded", function() {
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const designerIFrameContainerElement = document.querySelector(".designer-iframe-container");
    const designerIFrameElement = document.querySelector("#designer-iframe");

    const selectorsToObserve = ["#NavStandard", ".announcement-bar-static"];
    const observedElements = document.querySelectorAll(selectorsToObserve.join(', '));

    const observer = new ResizeObserver(function(entries) {
      const totalHeight = entries.reduce((acc, entry) => acc + entry.contentRect.height, 0);

      if (designerIFrameContainerElement !== null && designerIFrameElement !== null && totalHeight) {
        const heightValueString = isMobileDevice
          ? `calc(100dvh - ${totalHeight}px)`
          : `calc(100vh - ${totalHeight}px)`;

        designerIFrameContainerElement.style.height = heightValueString;
        designerIFrameElement.style.height = heightValueString;
      }
    });
    observedElements.forEach(element => observer.observe(element));
  });

  } catch(e) { console.error(e); }
})();
})();
